import React from "react";
import * as S from "./Select.styled";

const Select = ({
  selected,
  setSelected,
  title,
  placeholder,
  options,
  errorMessage,
  disabled,
  ...props
}) => {
  const hasError =
    selected.touched &&
    (selected.value === placeholder || selected.value === "");
  return (
    <S.SelectContainer disabled={disabled}>
      <S.CompanySelect
        {...props}
        label={title}
        placeholder={placeholder}
        onChange={(e) => {
          setSelected((company) => ({
            ...company,
            value: e.target.value,
            label: e.target.text,
            touched: true,
          }));
        }}
        error={hasError}
        errorMessage={hasError ? errorMessage : ""}
      >
        {options.map(({ value, label }) => (
          <S.Item
            key={value}
            value={value}
            text={label}
            selected={selected.label === label}
          />
        ))}
      </S.CompanySelect>
    </S.SelectContainer>
  );
};

export default Select;
